window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

try {
    window.axios = require('axios');
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    let token = document.head.querySelector('meta[name="csrf-token"]');

    if (token) {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    } else {
        console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    }
} catch (e) {
    console.log(e);
}

/**
 * Next, we will load all of this project's JavaScript dependencies, which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
// import Editor from '@ckeditor/ckeditor5-build-classic';
import Editor from "../../public/vendor/ckeditor5/src/ckeditor";

require('@noardcode/compass-core');
require('@noardcode/compass-side-panels');
require('@noardcode/compass-forms');

import autosize from "autosize";

require("./modules/projects")
require("./modules/tab-projects")
require("./modules/tab-dossier")
require("./modules/forms/hide-inputs")

$(document).ready(function () {
    require('./modules/forms/upload-pdf-preview.js');
    require('./modules/forms/dossier-request-type-select.js');
    require('./modules/dashboard/projects-toggle.js');
    require('./modules/dashboard/my-dossier-requests.js');
    require("./modules/settings/ledgers")
    require("./modules/forms/ckeditor")

    if ($("#dossier-price-agreements").length) {
        require('./modules/dossiers/price-agreements/attachment-upload.js');
        require('./modules/dossiers/price-agreements/price-agreement-table.js');
    }

    if ($("#filemanager").length) {
        require('./modules/file-manager/file-manager-uploader.js');
        require('./modules/file-manager/file-manager-ai-analysis.js');
        require('./modules/file-manager/file-manager-fields.js');
        require('./modules/file-manager/download-warning.js');
    }

    if ($("#file_manager_questionnaire").length) {
        require('./modules/file-manager/file-manager-questionnaire.js');
        require('./modules/folders/questionnaires.js');
        require('./modules/file-manager/download-warning.js');
    }

    require('./modules/digidos-kvk')

    if ($('#drag-and-drop-file-selector').length) {
        require('./modules/file-manager/drag-and-drop-upload')
    }

    if ($('.drag-and-drop-file-selector-dossier').length) {
        require('./modules/dossiers/drag-and-drop-upload')
    }

    if ($("#qr-setup-modal").length) {
        require('./modules/qr-app-login.js');
    }

    $('.autosize').each(function () {
        autosize(this);
    });

    if ($('#appReminderModal').length) {
        require('./modules/modals/app-reminder-modal');
    }

    if ($('#payment-completed-page').length) {
        require('./modules/payment-completed');
    }

    $('#authReminderModal').modal('show');
});
